import React, { useEffect, useState } from "react";
import api from "../../lib/api";

const STRENGTH_COLORS = ["#EF4444", "#F59E0B", "#F59E0B", "#3B82F6", "#10B981"];

export default function PasswordStrength({ password }) {
  const [data, setData] = useState({ score: 0, label: "Too weak", issues: [], valid: false });

  useEffect(() => {
    if (!password) {
      setData({ score: 0, label: "Too weak", issues: [], valid: false });
      return;
    }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.post("/api/auth/password-strength", { password });
        setData(data);
      } catch {}
    }, 200);
    return () => clearTimeout(t);
  }, [password]);

  const score = data.score || 0;

  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1.5 mb-1.5">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full transition-colors duration-300"
            style={{ background: i < score ? STRENGTH_COLORS[score] : "#E2E8F0" }}
          />
        ))}
      </div>
      <div className="flex items-center justify-between">
        <span className="t-caption font-medium" style={{ color: password ? STRENGTH_COLORS[score] : "#94A3B8" }}>
          {password ? data.label : "Enter a password"}
        </span>
        <span className="t-caption">Min. 12 chars · upper · lower · number · symbol</span>
      </div>
      {password && data.issues && data.issues.length > 0 && (
        <ul className="mt-2 space-y-0.5">
          {data.issues.map((issue, idx) => (
            <li key={idx} className="t-caption" style={{ color: "#92400E" }}>• {issue}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
